function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["buttonProps", "disabled", "initial", "labels", "loading", "nextDisabled", "onPageChange", "previousDisabled", "total"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useState, useEffect, useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import { ButtonLooks } from "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import { FontIcons } from "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../utilities/color.js";
import 'date-fns';
import "../../../../utilities/locale.js";
import "../../../../hooks/use-prevent-keyboard-scrolling.js";
import { useRtl } from "../../../../hooks/use-rtl.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../atoms/icon/font-icon/font-icon.js";
import 'react-transition-group';
import "../../../atoms/alert/inline-alert/inline-alert.js";
import "../../../atoms/alert/standard-alert/standard-alert.js";
import 'boring-avatars';
import "../../../atoms/tooltip/hover-tooltip/hover-tooltip.js";
import 'react-laag';
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import '@brandfolder/utilities';
import "../../../atoms/button/close-button/close-button.js";
import "../../../atoms/button/color-button/color-button.js";
import "../../../atoms/button/icon-button/icon-button.js";
import { StandardButton } from "../../../atoms/button/standard-button/standard-button.js";
import "../../../atoms/loader/circle-loader/circle-loader.js";
import "../../../atoms/loader/shimmer-loader/shimmer-loader.js";
import "../../../atoms/divider/standard-divider/standard-divider.js";
import "../../../atoms/fieldset/standard-fieldset/standard-fieldset.js";
import "../../../atoms/heading/standard-heading/standard-heading.js";
import "../../../atoms/label/standard-label/standard-label.js";
import "../../../atoms/link/button-link/button-link.js";
import "../../../atoms/link/standard-link/standard-link.js";
import "../../../atoms/popout/standard-popout/standard-popout.js";
import "../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js";
import "../../../atoms/table/standard-table/caption.js";
import "../../../atoms/table/standard-table/tbody.js";
import "../../../atoms/table/standard-table/tr-empty.js";
import "../../../atoms/table/standard-table/td.js";
import "../../../atoms/table/standard-table/tr.js";
import "../../../atoms/table/standard-table/table.js";
import "../../../atoms/table/standard-table/tfoot.js";
import "../../../atoms/table/standard-table/th.js";
import "../../../atoms/table/standard-table/thead.js";
import "../../../atoms/table/dnd-table/dnd-handle-td.js";
import "../../../atoms/table/dnd-table/dnd-table-drag-context.js";
import "../../../atoms/text/help-text/help-text.js";
import "../../../atoms/text/standard-text/standard-text.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var UnstyledNextPreviousPagination = function UnstyledNextPreviousPagination(props) {
  var buttonProps = props.buttonProps,
    disabled = props.disabled,
    initial = props.initial,
    _props$labels = props.labels,
    labels = _props$labels === void 0 ? {
      nextLabel: '',
      previousLabel: ''
    } : _props$labels,
    loading = props.loading,
    nextDisabled = props.nextDisabled,
    onPageChange = props.onPageChange,
    previousDisabled = props.previousDisabled,
    total = props.total,
    otherProps = _objectWithoutProperties(props, _excluded);
  var nextLabel = labels.nextLabel,
    previousLabel = labels.previousLabel;
  var _useRtl = useRtl(),
    isRtl = _useRtl.isRtl;
  var _useState = useState(initial || 1),
    _useState2 = _slicedToArray(_useState, 2),
    current = _useState2[0],
    setCurrent = _useState2[1];
  var _useState3 = useState(FontIcons.ArrowRight),
    _useState4 = _slicedToArray(_useState3, 2),
    iconNext = _useState4[0],
    setIconNext = _useState4[1];
  var _useState5 = useState(FontIcons.ArrowLeft),
    _useState6 = _slicedToArray(_useState5, 2),
    iconPrevious = _useState6[0],
    setIconPrevious = _useState6[1];
  var isCurrentFirst = current === 1;
  var isCurrentLast = current === total;
  var isDisabled = disabled || loading;
  useEffect(function () {
    if (isRtl) {
      setIconNext(FontIcons.ArrowLeft);
      setIconPrevious(FontIcons.ArrowRight);
    } else {
      setIconNext(FontIcons.ArrowRight);
      setIconPrevious(FontIcons.ArrowLeft);
    }
  }, [isRtl]);
  var onPage = function onPage(page) {
    setCurrent(page);
    onPageChange(page);
  };
  var renderNextPrevious = function renderNextPrevious(type) {
    var _classnames;
    var disablePrevious = type === 'previous' && (previousDisabled || isCurrentFirst);
    var disableNext = type === 'next' && (nextDisabled || isCurrentLast);
    var disableNextPrevious = isDisabled || disableNext || disablePrevious;
    var startIcon = type === 'previous' ? iconPrevious : undefined;
    var endIcon = type === 'next' ? iconNext : undefined;
    var label = type === 'next' ? nextLabel : previousLabel;
    var page = type === 'next' ? current + 1 : current - 1;
    return /*#__PURE__*/React.createElement(StandardButton, _extends({}, buttonProps, {
      className: classnames((_classnames = {}, _defineProperty(_classnames, "bf-pagination__".concat(type), true), _defineProperty(_classnames, "bf-pagination__".concat(type, "--disabled"), disableNextPrevious), _defineProperty(_classnames, "".concat(buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className), !!(buttonProps !== null && buttonProps !== void 0 && buttonProps.className)), _classnames)),
      disabled: disableNextPrevious,
      startIcon: startIcon,
      endIcon: endIcon,
      look: (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.look) || ButtonLooks.Default,
      onClick: disableNextPrevious ? undefined : function () {
        return onPage(page);
      },
      onKeyUp: function onKeyUp(e) {
        if (e.key === 'Enter' && !disableNextPrevious) {
          onPage(page);
        }
      }
    }), label);
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
    className: classnames(_defineProperty({
      'bf-pagination': true,
      'bf-pagination__next-previous': true,
      'bf-pagination__next-previous--disabled': disabled
    }, "".concat(otherProps === null || otherProps === void 0 ? void 0 : otherProps.className), !!(otherProps !== null && otherProps !== void 0 && otherProps.className)))
  }), renderNextPrevious('previous'), renderNextPrevious('next'));
};
var StyledNextPreviousPagination = styled(UnstyledNextPreviousPagination)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n"])));
/**
 * Pagination allows a user to move between pages of content such as search results.
 * Note that this pagination component uses `<button>` tags (it does not use `<a>` tags to change the URL).
 *
 * This simplified variant is used when the consumer is unable to reliably provide a total value or
 * does not want the user to be able to select specific pages. For example, use this variant when consuming
 * an API that uses [cursor pagination](https://jsonapi.org/profiles/ethanresnick/cursor-pagination/).
 *
 * https://developer.mozilla.org/en-US/docs/Web/CSS/Layout_cookbook/Pagination
 *
 *
 * @param props NextPreviousPaginationProps
 * @returns FunctionComponent<NextPreviousPaginationProps>
 */
var NextPreviousPagination = function NextPreviousPagination(props) {
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(StyledNextPreviousPagination, _extends({}, props)));
};
export { NextPreviousPagination };